import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import SkeletonText from "components/ui/skeleton/SkeletonText";

/**
 * Shared presentational chrome for buying-signals lead cards, used by both the single-document
 * Find Leads panel (DocumentFindLeads) and the bulk Buying Signals tab (DocumentBuyingSignalsResults)
 * so the two surfaces share one look and feel.
 */
export const BuyingSignalCard = styled(Flex)(({ theme }) => ({
  padding: 16,
  border: `1px solid ${theme.colors.sysBorderDecorative}`,
  borderRadius: 6,
}));

export const ScrollableLeadList = styled.div({
  maxHeight: "80vh",
  overflowY: "auto",
});

const BUYING_SIGNALS_SKELETON_DELAYS_MS = [0, 120, 200];

export function BuyingSignalsSkeleton() {
  return (
    <Flex column gap={16} aria-label="Loading buying signals">
      {BUYING_SIGNALS_SKELETON_DELAYS_MS.map((delayMs, index) => (
        <SkeletonText
          key={index}
          width="100%"
          fontSize={32}
          lineHeight={1}
          backgroundColor="sysBorderDecorative"
          customSpacing={true}
          animationDelayMs={delayMs}
          variant="rectangular"
        />
      ))}
    </Flex>
  );
}
